import { InjectionToken } from '@angular/core';

// A host app plugs its own toast/notification implementation in via this token; the shared editor
// stays app-agnostic. Optional by design — where it is not provided, the editor simply stays silent.
export interface EditorNotifier {
  success(message: string): void;
  error(message: string, detail?: string): void;
}

export const EDITOR_NOTIFIER = new InjectionToken<EditorNotifier>('EDITOR_NOTIFIER');
